// @ts-nocheck
import * as React from "react";

const Export: React.FC = () => {
    return (
        /* Store Custom Code - Start */
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <path
                fill="currentColor"
                d="m12 5 3.538 3.538-.708.719-2.331-2.331v8.65h-1V6.927L9.168 9.258l-.708-.719 3.538-3.538ZM6.615 19c-.46 0-.845-.154-1.153-.462s-.463-.693-.463-1.153v-2.423h1v2.423c0 .154.064.295.192.423a.588.588 0 0 0 .423.192h10.769a.588.588 0 0 0 .423-.192.588.588 0 0 0 .192-.423v-2.423h1v2.423c0 .46-.154.845-.462 1.153s-.693.462-1.153.462H6.615Z"
            />
        </svg>
        /* Store Custom Code - End */
    );
};

export default React.memo(Export);
